#######
# Start the app!
#
# Determines which application to run.
#
# These are the available applications at this time: 
#
#     franklin: The main considerit application
#     product_page: The considerit homepage for marketing considerit
#     proposal_embed: an embedable, read-only representation of a proposal

( ->

  # Add defined styles

  style = document.createElement('style')
  style.type = 'text/css'
  if style.styleSheet
    style.styleSheet.cssText = window.styles
  else
    style.appendChild document.createTextNode(window.styles)

  document.body.appendChild style

  container = document.getElementById('content')
  root = ReactDOM.createRoot(container)

  setTimeout ->
    ahoy?.configure({cookies: false})    
    root.render Saas({key: 'saas_root'})
)()


/** WEBPACK FOOTER **
 ** ../wwwconsiderit/@client/product_page/app_loader.coffee
 **/